/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ locale: NonNullable<unknown> }} Property_Ai_Generate_DescriptionInputs */

const cs_property_ai_generate_description = /** @type {(inputs: Property_Ai_Generate_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Vygenerovat popis (${i?.locale})`)
};

const en_property_ai_generate_description = /** @type {(inputs: Property_Ai_Generate_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Generate description (${i?.locale})`)
};

/**
* | output |
* | --- |
* | "Generate description ({locale})" |
*
* @param {Property_Ai_Generate_DescriptionInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const property_ai_generate_description = /** @type {((inputs: Property_Ai_Generate_DescriptionInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Property_Ai_Generate_DescriptionInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_property_ai_generate_description(inputs)
	return cs_property_ai_generate_description(inputs)
});